import { useEffect } from "react";
import { logout, completeLogout } from "../auth";
import { Navigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Hooks";

const Logout = () => {
  const error = useAppSelector(state => state.auth.error);
  let location = useLocation();
  let dispatch = useAppDispatch();

  useEffect(() => {
    if (location.pathname === "/logout/response") {
      dispatch<any>(completeLogout());
    } else {
      dispatch<any>(logout());
    }
  }, [location, dispatch]);

  if (error) {
    return <>{error.message}</>;
  } else {
    return <Navigate to={{ pathname: "/" }} />;
  }
}

export default Logout;
